module.exports = __webpack_public_path__ + "assets/img/NPC038.1d7d4644.png";